import useQueryParams from '@common/src/hooks/useQueryParams';
import {
  AnvaProduct,
  useAnvaProducts,
} from '@flows/src/api/anva-flows/getAnvaProducts';
import { FLOWS_CONFIG_PATH } from '@flows/src/FlowsConfigRouter';
import { useFlowsConfigureStore } from '@flows/src/store/zustand/flows-configure/flowsConfigureStore';
import { PartyType } from '@parties/src/types';
import QuestionViewSkeleton from '@sales-conversation/src/components/skeletons/QuestionViewSkeleton';
import useStartAnvaFlow, {
  AnvaFlowProduct,
} from '@sales-conversation/src/hooks/anva/useStartAnvaFlow';
import { FC, useEffect } from 'react';
import { useHistory, useParams } from 'react-router';

interface getProductsFromConfigProps {
  catalogue: AnvaProduct[];
  insurances: string[];
  companies: Record<string, string[]>;
  coverages: Record<string, string[]>;
}

const getProductsFromConfig = (
  params: getProductsFromConfigProps,
): AnvaFlowProduct[] => {
  const { catalogue } = params;
  const { insurances: chosenInsurances, companies, coverages } = params;

  return catalogue.reduce((acc, product) => {
    const { insurance, insurance_company } = product;
    const flowProduct = {
      id: product.id,
      coverages: coverages[insurance.id],
    };
    if (
      chosenInsurances.includes(insurance.id) &&
      companies[insurance.id]?.includes(insurance_company.id)
    ) {
      acc.push(flowProduct);
    }
    return acc;
  }, [] as AnvaFlowProduct[]);
};

const FlowsConfigureFinish: FC = () => {
  const queryParams = useQueryParams();
  const partyType = (queryParams.get('type') as PartyType) || 'CUSTOMER';
  const { data: catalogue, isSuccess } = useAnvaProducts(partyType);
  const startAnvaFlow = useStartAnvaFlow();
  const { flowId } = useParams<{ flowId: string }>();
  const history = useHistory();

  useEffect(() => {
    if (!catalogue || !flowId) return;
    const state = useFlowsConfigureStore.getState();
    if (!state.insurances)
      return history.push({
        pathname: `${FLOWS_CONFIG_PATH}/${flowId}`,
        search: window.location.search,
      });
    const { items } = catalogue;
    const products = getProductsFromConfig({
      catalogue: items,
      insurances: state.insurances,
      companies: state.companies,
      coverages: state.coverages,
    });
    // start flow will come here
    startAnvaFlow({
      flowId: flowId,
      inputUrl: `${FLOWS_CONFIG_PATH}/${flowId}`,
      partyId: queryParams.get('partyId') || undefined,
      anva_products: products,
    });
  }, [isSuccess]);

  return <QuestionViewSkeleton />;
};

export default FlowsConfigureFinish;
